import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

export const PanMitraRedirectURL = () => {
    const location = useLocation();
    const history = useHistory();
    const RedirectURL = location.state.RedirectURL;

    useEffect(() => {
        // Redirect to the specified URL
        window.location.href = RedirectURL;
    }, [RedirectURL]);

    // No need to return any JSX since we're redirecting
    return null;
}